import React from 'react';
import '../CSS/BillReview.css';
import billReviewHeroImg from '../Images/services/Bill Review Services/services-bill-review-services.png';
import billReviewHeroImgMob from '../Images/Mobile Images/services/Bill Review Services/service-bill-review-banner-image-moble.png';
import { Box } from '@mui/material';
import greenTick from '../Images/green-tick-icon.svg';
import billReviewSectionImg from '../Images/services/Bill Review Services/bill-review-services-section-image.png';
import claimManagementImgMob from '../Images/Mobile Images/services/Bill Review Services/claim-management-section-image-mobile.png';
import expertReviewImgMob from '../Images/Mobile Images/services/Bill Review Services/expert-review-section-image-mobile.png';
import { useNavigate } from 'react-router-dom';

const BillReview: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="bill-review-hero">
        <div
          className="bill-review-hero-img"
          style={{ '--hero-bg': `url(${billReviewHeroImg})`, '--hero-bg-mob': `url(${billReviewHeroImgMob})`, backgroundImage: `url(${billReviewHeroImg})` } as React.CSSProperties}
        >
          <div className="bill-review-hero-content">
            <div className="bill-review-hero-title">Bill Review Services</div>
            <div className="bill-review-hero-main">Minimize Administrative Load. Maximize Billing Efficiency.</div>
            <div className="bill-review-hero-desc">
              Our certified bill review teams ensure low bill aging, enhanced accuracy, and reduced healthcare costs.
            </div>
          </div>
        </div>
      </div>
      {/* Bill Review Services Section */}
      <div className="bill-review-services">
        <div className="brs-left">
          <div className="brs-heading">Bill Review Services</div>
          <div className="brs-desc">Comprehensive support through every stage of the billing review process.</div>
          <button onClick={() => navigate('/contact-us#contact-us-top')} className="brs-contact-btn">Contact Us</button>
        </div>
        <div className="brs-right">
          <div className="brs-card-grid">
            <div className="brs-card">
              <div className="brs-card-title">Nurse Audit</div>
              <div className="brs-card-desc">Reviewing the request for medical necessity and approving the case if it meets the required guidelines</div>
            </div>
            <div className="brs-card">
              <div className="brs-card-title">Repricing & Rules Application</div>
              <div className="brs-card-desc">Extensive coding review and repricing, fee schedules, and state law adjustments</div>
            </div>
            <div className="brs-card">
              <div className="brs-card-title">Reconsideration</div>
              <div className="brs-card-desc">Appeals validity, 2nd review, and PPO reconsiderations</div>
            </div>
            <div className="brs-card">
              <div className="brs-card-title">Data Capture</div>
              <div className="brs-card-desc">OCR or manual KFI across bill types</div>
            </div>
          </div>
        </div>
      </div>
      {/* AI Services for Bill Review Services Section */}
      <div className="ai-services-billreview-section">
        <div className="ai-services-billreview-section-left">
          <div className="ai-services-billreview-section-title">AI Services for Bill Review Services</div>
          <div className="ai-services-billreview-section-subtitle">Claims Management</div>
          <div className="ai-services-billreview-section-label">Traditional Process</div>
          <div className="ai-services-billreview-section-desc">Excel-based KPI reports with manual benchmarking</div>
          <div className="ai-services-billreview-section-label" style={{ marginTop: 24 }}>AI Enhancement</div>
          <div className="ai-services-billreview-section-desc">AI dashboards with predictive analytics for cash flow forecasting</div>
          <div className="ai-services-billreview-section-label" style={{ marginTop: 24 }}>Outcomes</div>
          <ul className="ai-services-billreview-section-list">
            <li>Better financial planning</li>
            <li>Faster issue detection</li>
          </ul>
        </div>
        <div className="ai-services-billreview-section-right">
          <picture>
            <source media="(max-width: 1100px)" srcSet={claimManagementImgMob} />
            <img src={require('../Images/services/Bill Review Services/claim-management-section-image.png')} alt="AI Services for Bill Review Illustration" className="ai-services-billreview-section-img" />
          </picture>
        </div>
      </div>
      {/* Expert Bill Review Section */}
      <div className="expert-bill-review">
        <div className="ebr-left">
          <img src={billReviewSectionImg} alt="Bill Review Services Section" className="ebr-img" />
        </div>
        <div className="ebr-right">
          <div className="ebr-title">Expert Review Across All Bill Types and Complexities</div>
          <div className="ebr-desc">We provide specialized review services for a wide range of medical bills, including:</div>
          <ul className="ebr-list">
            <li><img src={greenTick} alt="Green Tick" className="ebr-tick" /><span className="ebr-list-text"><b>Provider Bills</b></span></li>
            <li><img src={greenTick} alt="Green Tick" className="ebr-tick" /><span className="ebr-list-text"><b>Texas (TX) Jurisdiction Bills</b></span></li>
            <li><img src={greenTick} alt="Green Tick" className="ebr-tick" /><span className="ebr-list-text"><b>Hospital Inpatient and Outpatient Bills</b></span></li>
            <li><img src={greenTick} alt="Green Tick" className="ebr-tick" /><span className="ebr-list-text"><b>California Laboratory & Pathology Bills</b></span></li>
          </ul>
        </div>
      </div>
      {/* Bill Review Metrics Section */}
      <div className="bill-review-metrics">
        <div className="bill-review-metrics-heading">
          Quality Isn't Just a Metric—It's a Mission. <b>Medwell360 Delivers Nothing Less.</b>
        </div>
        <div className="bill-review-metrics-row">
          <div className="bill-review-metrics-item">
            <div className="bill-review-metrics-value">99%</div>
            <div className="bill-review-metrics-label">Annual Reviews</div>
          </div>
          <div className="bill-review-metrics-item">
            <div className="bill-review-metrics-value">24 hr+</div>
            <div className="bill-review-metrics-label">Standard Quality Audits</div>
          </div>
          <div className="bill-review-metrics-item">
            <div className="bill-review-metrics-value">20+</div>
            <div className="bill-review-metrics-label">Healthcare IT Platforms</div>
          </div>
          <div className="bill-review-metrics-item">
            <div className="bill-review-metrics-value">99%</div>
            <div className="bill-review-metrics-label">Client Satisfaction</div>
          </div>
        </div>
      </div>
      {/* Bill Review Project Management Framework Section */}
      <div className="bill-review-project-framework">
        <div className="bill-review-project-framework-heading">Robust Project Management Framework</div>
        <div className="bill-review-project-framework-steps">
          <div className="bill-review-project-framework-step">
            <div className="bill-review-project-framework-circle">1</div>
          </div>
          <div className="bill-review-project-framework-line" />
          <div className="bill-review-project-framework-step">
            <div className="bill-review-project-framework-circle">2</div>
          </div>
          <div className="bill-review-project-framework-line" />
          <div className="bill-review-project-framework-step">
            <div className="bill-review-project-framework-circle">3</div>
          </div>
          <div className="bill-review-project-framework-line" />
          <div className="bill-review-project-framework-step">
            <div className="bill-review-project-framework-circle">4</div>
          </div>
        </div>
        <div className="bill-review-project-framework-labels">
          <div className="bill-review-project-framework-label-wrapper">
            <div className="bill-review-project-framework-step-inline"><div className="bill-review-project-framework-circle">1</div></div>
            <div className="bill-review-project-framework-label">
              <div className="bill-review-project-framework-label-title">Technology</div>
              <div className="bill-review-project-framework-label-desc">Secure integration with IT systems across our compliant contact center environments.</div>
            </div>
          </div>
          <div className="bill-review-project-framework-label-wrapper">
            <div className="bill-review-project-framework-step-inline"><div className="bill-review-project-framework-circle">2</div></div>
            <div className="bill-review-project-framework-label">
              <div className="bill-review-project-framework-label-title">Staff Onboarding</div>
              <div className="bill-review-project-framework-label-desc">Structured onboarding processes ensure accurate, timely, and efficient service delivery from day one.</div>
            </div>
          </div>
          <div className="bill-review-project-framework-label-wrapper">
            <div className="bill-review-project-framework-step-inline"><div className="bill-review-project-framework-circle">3</div></div>
            <div className="bill-review-project-framework-label">
              <div className="bill-review-project-framework-label-title">Training</div>
              <div className="bill-review-project-framework-label-desc">Our teams are trained on your content and must pass certification to ensure full comprehension and alignment.</div>
            </div>
          </div>
          <div className="bill-review-project-framework-label-wrapper">
            <div className="bill-review-project-framework-step-inline"><div className="bill-review-project-framework-circle">4</div></div>
            <div className="bill-review-project-framework-label">
              <div className="bill-review-project-framework-label-title">Quality Assurance</div>
              <div className="bill-review-project-framework-label-desc">Key performance metrics are clearly defined, with established remediation protocols to maintain consistent quality and compliance.</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BillReview; 